import React from 'react';
import classNames from 'classnames';
import _chunk from 'lodash/chunk';
import PropTypes from 'prop-types';

import { generateKeyForList } from 'utils';

import sitemapClasses from '../../css/sitemap.module.css';

const propTypes = {
  title: PropTypes.any,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      mainTitle: PropTypes.string.isRequired,
      mainLink: PropTypes.string.isRequired,
      subLinks: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          link: PropTypes.string.isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
  totalColumns: PropTypes.oneOf([1, 2, 3, 4, 6, 12]),
  className: PropTypes.string,
  boldLinks: PropTypes.bool,
  noGutters: PropTypes.bool,
};
const defaultProps = {
  totalColumns: 3,
  className: '',
  boldLinks: true,
  noGutters: true,
};

const SitemapLinksSection = ({ title, links, totalColumns, className, boldLinks, noGutters }) => {
  const linksChunks = _chunk(links, Math.ceil(links.length / totalColumns));
  return (
    <div className={classNames('row', className, { 'no-gutters': noGutters })}>
      {title && <div className="col-lg-12 main_inner">{title}</div>}
      {linksChunks.map((linkItem, index) => (
        <div className={`col-12 col-lg-${parseInt(12 / totalColumns)}`} key={`jobs - ${index} `}>
          <ul className="site-nav">
            {linkItem.map((item) => (
              <React.Fragment key={item.mainTitle}>
                <li className={classNames('list-unstyled mb-1', { 'font-weight-600': boldLinks })}>
                  {item.mainLink ? (
                    <a href={item.mainLink} className="list-link">
                      {item.mainTitle}
                    </a>
                  ) : (
                    <span className="zippia-blue-text">{item.mainTitle}</span>
                  )}
                </li>
                <ul className={`${sitemapClasses.sitemapIndustryJobTitlesLinks}`}>
                  {item.subLinks?.map((subLink, index) => (
                    <li key={generateKeyForList(index, subLink.title)}>
                      <a className="greyLabel" href={subLink.link}>{` ${subLink.title} `}</a>
                    </li>
                  ))}
                </ul>
              </React.Fragment>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

SitemapLinksSection.propTypes = propTypes;
SitemapLinksSection.defaultProps = defaultProps;

export default SitemapLinksSection;
